const initialState = {
  userList: [],
  user: {},
  totalRecord: 0,
  userEmailVerification: false,
  lastJoinedUserList: [],
};

const userManagement = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USER_LIST": {
      const userList = action.payload.rows;
      const totalRecord = action.payload.count;
      return {
        ...state,
        userList: userList.sort((a, b) => {
          return [a.firstName, a.lastName].join().toLocaleLowerCase() >
            [b.firstName, b.lastName].join().toLocaleLowerCase()
            ? 1
            : -1;
        }),
        totalRecord,
      };
    }
    case "FETCH_USER_LIST_WITH_EXCLUDED_USER_IDS": {
      const userList = action.payload.rows;
      const totalRecord = action.payload.count;
      return {
        ...state,
        userList: userList.sort((a, b) => {
          return [a.firstName, a.lastName].join().toLocaleLowerCase() >
            [b.firstName, b.lastName].join().toLocaleLowerCase()
            ? 1
            : -1;
        }),
        totalRecord,
      };
    }
    case "FETCH_USER": {
      return { ...state, user: action.payload };
    }
    case "CLEAR_USER": {
      return { ...state, user: {} };
    }
    case "USER_EMAIL_VERIFICATION": {
      return { ...state, userEmailVerification: action.payload };
    }
    case "CREATE_USER": {
      const newUser = action.payload;
      return {
        ...state,
        totalRecord: state.totalRecord + 1,
        userList: state.userList
          .concat(newUser)
          .slice()
          .sort((a, b) => {
            return [a.firstName, a.lastName].join().toLocaleLowerCase() >
              [b.firstName, b.lastName].join().toLocaleLowerCase()
              ? 1
              : -1;
          }),
      };
    }
    case "EDIT_USER": {
      let usersWithoutEdited = state.userList.filter(
        (u) => u.id !== action.payload.id
      );
      return {
        ...state,
        userList: [...usersWithoutEdited, action.payload]
          .slice()
          .sort((a, b) => {
            return [a.firstName, a.lastName].join().toLocaleLowerCase() >
              [b.firstName, b.lastName].join().toLocaleLowerCase()
              ? 1
              : -1;
          }),
      };
    }
    case "SET_PROFILE": {
      let setProfile = state.userList.filter((u) => u.id !== action.payload.id);
      return {
        ...state,
        userList: [...setProfile, action.payload].slice().sort((a, b) => {
          return [a.firstName, a.lastName].join().toLocaleLowerCase() >
            [b.firstName, b.lastName].join().toLocaleLowerCase()
            ? 1
            : -1;
        }),
      };
    }
    case "DELETE_USER": {
      var deletedList = state.userList.filter(
        (x) => !action.payload.includes(x.id)
      );
      return {
        ...state,
        totalRecord: state.totalRecord - 1,
        userList: deletedList,
      };
    }
    case "FETCH_LAST_USER_LIST": {
      let sortedList = action.payload.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      return { ...state, lastJoinedUserList: sortedList };
    }
    default:
      return state;
  }
};

export default userManagement;
